module.exports = __webpack_public_path__ + "static/media/tools.be8185fb.svg";